module.exports = __webpack_public_path__ + "media/packs/images/flags/GT-19b8060d1c3d08601e1e896757e5be5e.svg";